import { FC } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document } from '@contentful/rich-text-types';
import { options } from './nodes';

export interface RichTextProps {
  content: Document;
  variant?: 'regular' | 'small';
  className?: string;
}

const RichText: FC<RichTextProps> = ({ content, variant = 'regular', className = '' }) => {
  return (
    <div className={`flex flex-col gap-y-8 ${className}`}>{documentToReactComponents(content, options[variant])}</div>
  );
};

export default RichText;
